export default __webpack_public_path__ + "media/images/minimum-orders-599707df130b91c828c7160f1d9fad1c.svg";